import React, { Component } from 'react';
import { Result } from './result';
import algolia_logo from './search-by-agolia.svg';

import {
  Pagination, Menu, InstantSearch, Hits, SearchBox, Configure
} from 'react-instantsearch/dom';

class App extends Component {
  render() {
    const query = {};
    window.location.search
    .replace('?', '').split('&')
    .forEach(param => {
      const parts = param.split('=');
      query[parts[0]] = parts[1];
    });

    return (
      <div className="instant-search">
        <InstantSearch
          appId="WPRUF0HT5B"
          apiKey="72b5af554b3ec483842153a777f0b3f0"
          indexName="deltaflex.content"
        >
          <Configure
            attributesToSnippet={["content:70"]}
          />
          {/* Search widgets will go there */}
          <SearchBox defaultRefinement={query.search} />
          <Menu />
          <div className="container">
            <Hits hitComponent={Result} />
          </div>
          <Pagination />
        </InstantSearch>
        <img className="algolia-logo" src="/sites/all/themes/delta/search/build/static/media/search-by-agolia.c962a407.svg" />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js